/**
 * Pikestee layout behaviour (styles: assets/pikestee-layout.css).
 * - Desktop header: dropdown menus open on hover (click and keyboard still work).
 * - Product page gallery: prev / next arrows on the image itself (the counter and thumbnails
 *   under the image are hidden), on mobile and desktop.
 */
(() => {
  if (window.__pikesteeLayout) return;
  window.__pikesteeLayout = true;

  /* ---------- Desktop: menus open on hover ---------- */
  const hoverDesktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const CLOSE_DELAY = 200;

  const menuDetails = () => document.querySelectorAll('.header__inline-menu details');

  const closeMenu = (details) => {
    if (details.hasAttribute('open')) details.removeAttribute('open');
  };

  document.addEventListener(
    'mouseover',
    (event) => {
      if (!hoverDesktop.matches) return;
      const details = event.target.closest?.('.header__inline-menu details');
      if (!details) return;
      clearTimeout(details.pkCloseTimer);
      menuDetails().forEach((other) => {
        if (other !== details && !other.contains(details)) closeMenu(other);
      });
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    },
    { passive: true },
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      if (!hoverDesktop.matches) return;
      const details = event.target.closest?.('.header__inline-menu details');
      if (!details || details.contains(event.relatedTarget)) return;
      clearTimeout(details.pkCloseTimer);
      details.pkCloseTimer = setTimeout(() => closeMenu(details), CLOSE_DELAY);
    },
    { passive: true },
  );

  // A mouse click on a menu that hovering already opened must not close it again.
  document.addEventListener('click', (event) => {
    if (!hoverDesktop.matches || event.detail === 0) return;
    const summary = event.target.closest?.('.header__inline-menu summary');
    if (summary && summary.parentElement.hasAttribute('open')) event.preventDefault();
  });

  /* ---------- Product gallery: arrows on the image ---------- */
  const ARROW_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>';

  const galleryItems = (gallery) => [
    ...gallery.querySelectorAll('[id^="GalleryViewer"] .product__media-list > [data-media-id]'),
  ];

  // Index of the image currently shown: the active one on desktop, the scrolled-to one on mobile.
  const currentIndex = (gallery, items) => {
    if (gallery.mql?.matches) {
      const active = items.findIndex((item) => item.classList.contains('is-active'));
      return active < 0 ? 0 : active;
    }
    const list = items[0].parentElement;
    const distance = (item) => Math.abs(item.offsetLeft - items[0].offsetLeft - list.scrollLeft);
    let best = 0;
    items.forEach((item, index) => {
      if (distance(item) < distance(items[best])) best = index;
    });
    return best;
  };

  const go = (gallery, step) => {
    const items = galleryItems(gallery);
    if (items.length < 2 || typeof gallery.setActiveMedia !== 'function') return;
    const next = (currentIndex(gallery, items) + step + items.length) % items.length;
    gallery.setActiveMedia(items[next].dataset.mediaId, false);
  };

  const addArrows = () => {
    document.querySelectorAll('product-info media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer || viewer.querySelector('.pk-gallery-arrow') || galleryItems(gallery).length < 2) return;
      [
        ['prev', -1, 'Previous image'],
        ['next', 1, 'Next image'],
      ].forEach(([name, step, label]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `pk-gallery-arrow pk-gallery-arrow--${name}`;
        button.setAttribute('aria-label', label);
        button.innerHTML = ARROW_ICON;
        if (step < 0) button.firstElementChild.style.transform = 'scaleX(-1)';
        button.addEventListener('click', () => go(gallery, step));
        viewer.appendChild(button);
      });
    });
  };

  const start = () => {
    addArrows();
    // The gallery can be re-rendered when the variant changes.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(addArrows, 0));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
